import { render, staticRenderFns } from "./PatternComparisonDialog.vue?vue&type=template&id=8f40e4f6&scoped=true"
import script from "./PatternComparisonDialog.vue?vue&type=script&lang=js"
export * from "./PatternComparisonDialog.vue?vue&type=script&lang=js"
import style0 from "./PatternComparisonDialog.vue?vue&type=style&index=0&id=8f40e4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f40e4f6",
  null
  
)

export default component.exports